import * as React from "react";
import "../../../assets/scss/Login/login/generic/yobInputField.scss";
import { integerExp } from "../../utils/regex";

export interface IYobInputFieldProps {
  autoFocus?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
  defaultValue?: string;
  type?: string;
  id?: string;
  disabled?: boolean;
  size?: number;
}

enum EKeyCodes {
  BACKSPACE = 8,
  LEFT_ARROW = 37,
  RIGHT_ARROW = 39,
}

const YobInputField: React.FC<IYobInputFieldProps> = (props) => {
  // stores the value of each input in array
  const [value, setValue] = React.useState(new Array(props.size ? props.size: 4).fill(""));

  // when focussed, this helps to colour the border of input_field_cont
  const [focusClass, setFocusClass] = React.useState("");

  function handleChange(v: string, i: number) {
    if (integerExp.test(v)) {
      const valueCopy = [...value];
      valueCopy[i] = v;

      setValue(valueCopy);
      props.onChange(valueCopy.join(""));
    }
  }

  // go to the previous input
  function goToPrevious(event: React.KeyboardEvent<HTMLInputElement>) {
    if(event.target.previousElementSibling){
      event.target.previousElementSibling.focus();
    }
    // const form = (event.target as HTMLInputElement).form;
    // const index = Array.prototype.indexOf.call(form, event.target);
    // const prevInp = form?.elements[
    //   index > 0 ? index - 1 : index
    // ] as HTMLInputElement;
    // prevInp.focus();
  }

  // go to next input
  function goToNext(event: React.KeyboardEvent<HTMLInputElement>) {
    if(event.target.nextElementSibling){
      event.target.nextElementSibling.focus();
    }
    // const form = (event.target as HTMLInputElement).form;
    // const index = Array.prototype.indexOf.call(form, event.target);
    // const nextInp = form?.elements[
    //   index < value.length - 1 ? index + 1 : index
    // ] as HTMLInputElement;
    // nextInp.focus();
  }

  function handleKeyUp(e: React.KeyboardEvent<HTMLInputElement>) {
    if (
      e.keyCode === EKeyCodes.BACKSPACE ||
      e.keyCode === EKeyCodes.LEFT_ARROW
    ) {
      // if backspace or left arrow is pressed
      goToPrevious(e);
    } else if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      e.keyCode === EKeyCodes.RIGHT_ARROW
    ) {
      // if number key or right arrow is pressed
      goToNext(e);
    }
  }
  React.useEffect(() => {
    if (props.defaultValue === "") {
      setValue(new Array(props.size ? props.size: 4).fill(""));
      let firstInputBox = document.getElementById("otp-0");
      if((props.autoFocus && props.autoFocus==true))
        firstInputBox?.focus();
    }
  }, [props.defaultValue]);

  return (
    <div className={"yob_inp_grp" + (props.disabled ? " disabled":"")}>
      {value.map((_, i) => (
        <input
          key={i}
          placeholder={props.placeholder}
          value={value[i] !== "" ? value[i] : ""}
          onChange={(e) => handleChange(e.target.value, i)}
          onFocus={() => setFocusClass(" focus")}
          onBlur={() => setFocusClass(" ")}
          className={"yob_inp mg-b10" + focusClass  + " " +props.id}
          type={props.type ? props.type : "password"}
          min={0}
          max={9}
          maxLength={1}
          onKeyUp={(e) => handleKeyUp(e)}
          id={props.id ? props.id + i : "yob-" + i}
          autoFocus={false}
          disabled={props.disabled}
        />
      ))}
    </div>
  );
};

export default YobInputField;
